module.exports = __webpack_public_path__ + "img/coordinate.fac08a26.jpg";